<template>
  <div class="addNewClass">
    <div class="content">
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>公告标题</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <div class="grid-content bg-purple name">
                  <el-input
                    v-model="formData.title"
                    placeholder="请输入内容"
                    size="small"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>公告图片</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <el-upload
                  name="image"
                  :data="imgdata"
                  class="avatar-uploader"
                  :show-file-list="false"
                  accept="image/jpeg,image/gif,image/png"
                  action="https://www.58zltc.com/api/Upload/uploads/"
                  :on-success="handleLogoSuccess"
                  :before-upload="beforeLogoUpload"
                >
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>小程序链接</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <div class="grid-content bg-purple name">
                  <el-input
                    v-model="formData.miniUrl"
                    placeholder="请输入内容"
                    size="small"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>公众号链接</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <div class="grid-content bg-purple name">
                  <el-input
                    v-model="formData.bjnewsUrl"
                    placeholder="请输入内容"
                    size="small"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>公告内容 </span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <EditorBar
              @change="changeeditor"
              v-model="formData.textCon"
            ></EditorBar>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>是否显示</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <template>
              <el-radio v-model="formData.showStatus" label="1">是</el-radio>
              <el-radio v-model="formData.showStatus" label="0">否</el-radio>
            </template>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" justify="end" type="flex" style="margin-bottom:40px">
        <el-col :span="4">
          <el-button type="primary" @click="submit">
            <span>提交</span>
          </el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import EditorBar from "@Components/public/wangEnduit";
import { mapGetters, mapActions } from "vuex";
import { pushAdList } from "@/api/announcement";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  components: {
    EditorBar
  },
  data() {
    return {
      imgdata: {},
      imageUrl: "",
      imageIdx: 0,
      formData: {
        title: "",
        img: "",
        miniUrl: "",
        bjnewsUrl: "",
        textCon: "",
        showStatus: "1"
      }
    };
  },
  mounted() {
    this.imgdata = {
      app_id: this.app_id,
      token: this.token,
      type: "1",
      file_group: "1"
    };
  },
  methods: {
    handleLogoSuccess(res, file) {
      console.log(res);
      this.$message(res.msg);
      if (res.code == 200) {
        this.imageIdx = res.data.id;
      }
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeLogoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传Logo图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    // 获取编辑器内容
    changeeditor(value) {
      this.formData.textCon = value;
    },
    returnUp() {
      this.$emit("closelabel", false);
    },
    addValue() {
      if (this.labelValue == "") {
        this.$message("请输入内容");
      } else {
        this.labelGroup.push(this.labelValue);
        this.labelValue = "";
        console.log(this.labelGroup);
      }
    },
    deletelabel(index) {
      this.labelGroup.splice(index, 1);
    },
    submit() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        store_id: 2, //后期改为选择店铺列表
        title: this.formData.title,
        logo: this.imageIdx,
        wapp_url: this.formData.miniUrl,
        wechat_url: this.formData.bjnewsUrl,
        content: this.formData.textCon,
        status: this.formData.showStatus
      };
      pushAdList(data).then(res => {
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        } else {
          console.log(res);
          this.$message({
            message: res.msg,
            type: "success"
          });
          setTimeout(() => {
            this.formData = {};
            this.$router.go(-1);
          }, 600);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #8c939d !important;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.addNewClass {
  height: 100%;
  position: relative;
  .content {
    position: absolute;
    overflow: auto;
    top: 0px;
    bottom: 26px;
    left: 22px;
    right: 70px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 20px 30px;
    .operation {
      height: 50px;
    }
    .el-row {
      margin-top: 15px;
    }
    .grid-content {
      line-height: 36px;
      min-height: 36px;
      .label {
        // width: 70px;
        line-height: 20px;
        // height: 20px;
        padding: 5px 15px;
        border-radius: 20px;
        background: rgba(64, 158, 255, 0.1);
        text-align: center;
        margin-right: 10px;
        position: relative;
        .close {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: #ff00004f;
          line-height: 15px;
          position: absolute;
          right: 0;
          top: -5px;
        }
      }
    }
    .labelsort {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .name {
      text-align: right;
    }
    .rgt {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .img {
    width: 80px;
    height: 80px;
    background: #ff00004f;
  }
}
</style>

<style lang="scss">
.addNewClass {
  .editor {
    width: 100%;
    .text {
      min-height: 220px;
    }
  }
}
</style>
